import ButtonLove from "components/Button/ButtonLove"
import React, { Component } from "react"

import { Modal, Button, Icon } from "semantic-ui-react"
// import Navigation from "../Navigation/Navigation"

import "./View3D.scss"

const BASE_URL_3D = "//www.trendimport.de/media/"

export default class View3D extends Component {

  state = {
    src: false,
  }

  componentDidMount() {
    this.load( this.props )
  }

  componentWillReceiveProps( props ) {
    this.load( props )
  }

  load( props ) {
    console.log( `loading 3d` )
    const { id } = props
    this.setState( { src: false } )
    const image = new Image()
    image.onload = () => {
      var src = BASE_URL_3D + id + "_360design/" + id + "/" + id + ".html"
      this.setState( { src } )
    }
    image.onerror = function ( e ) {

    }
    image.src = BASE_URL_3D + id + "_360design/" + id + "/Images/" + id + "/Lv2/img01.jpg"
  }

  render() {
    const { src } = this.state
    const { title } = this.props
    if ( !src ) return false
    return (
      <Modal dimmer="inverted"
             closeIcon={<div className="pa2"><Button circular icon="arrow left"/>{title}</div>} size={"large"}
             trigger={<Button className="View3D-button" >3D</Button>}>
        <div className="View3D">
          <iframe src={src} frameBorder="0"/>
        </div>
      </Modal>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Product/View3D.js